import {AuthenticationService} from '../../Services/AuthenticationService';
import {VersionService} from '../../Services/VersionService';
import {StorageService} from '../../Services/StorageService';
import {environment} from '../../../Environments/environment';
import {EAppUserType, IAppUser, IMobileUser, ProxyContainer} from '../../Data/Data';
import {CordovaService} from '../../Services/CordovaService';
import {NavigationService} from '../../Services/NavigationService';
import {TimeEntryDataService} from '../../Services/TimeEntryDataService';

export class AppController {
  static controllerId: string = 'AppController';

  static $inject = [
    AuthenticationService.serviceId,
    VersionService.serviceId,
    '$proxy',
    StorageService.serviceId,
    CordovaService.serviceId,
    NavigationService.serviceId,
    TimeEntryDataService.serviceId,
    '$timeout',
    '$rootScope',
  ];

  user: IAppUser;
  isReady: boolean = false;

  currentVersion: string;
  targetServerVersion: string;
  needsWakeLockPermission = false;

  wakeLock: WakeLockSentinel = null;

  requestWakeLock() {
    navigator.wakeLock.request('screen').then(wakeLock => {
      console.log('wake-lock: aquired');
      this.wakeLock = wakeLock;
      this.timeout(() => {
        this.needsWakeLockPermission = false;
      });
      wakeLock.addEventListener('release', () => {
        console.log('wake-lock: was released');
        wakeLock = null;
      });
    }, err => {
      console.error('wake-lock:', err);
      this.timeout(() => {
        this.needsWakeLockPermission = true;
      });
    });
  }

  constructor(private authentication: AuthenticationService,
              private version: VersionService,
              private $proxy: ProxyContainer,
              private storage: StorageService,
              private cordova: CordovaService,
              private navigation: NavigationService,
              private timeEntryData: TimeEntryDataService,
              private timeout: ng.ITimeoutService,
              private $rootScope: ng.IRootScopeService,
  ) {
    this.version.startVersionCheck();
    this.cordova.evaluateDeviceType();
    this.targetServerVersion = environment.targetServerVersion;
    this.authentication.startAppUserReload();
    this.authentication.startPinging();
    this.authentication.loadAppUser().then(appUser => {
      if (!appUser) {
        this.navigation.goToState('login');
        this.$rootScope.$on('appUserChanged', (event, changedUser: IMobileUser) => this.tryStartWakeLock(changedUser));
      } else {
        this.tryStartWakeLock(appUser);
      }
      this.isReady = true;
    }).catch(() => {
      this.navigation.goToState('login');
      this.isReady = true;
      this.$rootScope.$on('appUserChanged', (event, changedUser: IMobileUser) => this.tryStartWakeLock(changedUser));
    });

    this.version.getVersionNumber().then(version => {
      this.currentVersion = version;
    });

    this.timeEntryData.loadEntryTypes();
  }

  private tryStartWakeLock(appUser: IMobileUser) {
    if (!appUser) {
      return;
    }
    if (appUser.appUserType === EAppUserType.Terminal && 'wakeLock' in navigator) {
      this.requestWakeLock();
      const handleVisibilityChange = async () => {
        // add a delay to show the wake lock is restored on visibility change
        // so the user can see the checkbox is checked
        if (document.visibilityState === 'visible') {
          this.requestWakeLock();
        }
      };
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }
  }

  get isTest() {
    return environment.isTest;
  }

  hasClaim = (claim: string) => {
    return this.authentication.hasClaim(claim);
  };
}
